module.exports = __webpack_public_path__ + "static/coding_real_hey-3a71ca97a37537d31c29213ee0a95524.svg";